import { render, staticRenderFns } from "./SecurityAdd.vue?vue&type=template&id=61b63bf4"
import script from "./SecurityAdd.vue?vue&type=script&lang=js"
export * from "./SecurityAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports